<template>
    <div :class="control.additionalFieldClass" v-text="localizedText">
    </div>
</template>

<script>
    import {CONTROL_FIELD_EXTEND_MIXIN} from "../../mixins/control-field-extend-mixin";
    import { getLocalizedField } from "../../utils/languageHelper";

    /**
     * TextBlockControl - displays static text content
     * Supports Spanish localization via textEs field
     */
    export default {
        name: "TextBlockControl",
        mixins: [CONTROL_FIELD_EXTEND_MIXIN],

        computed: {
            /**
             * Get localized text based on current language
             * Falls back to English if Spanish not available
             */
            localizedText() {
                return getLocalizedField(this.control, 'text', this.language);
            }
        }
    }
</script>